import { render, staticRenderFns } from "./ActivityOpenQuestionItemOption.vue?vue&type=template&id=674a55e2&scoped=true&"
import script from "./ActivityOpenQuestionItemOption.vue?vue&type=script&lang=js&"
export * from "./ActivityOpenQuestionItemOption.vue?vue&type=script&lang=js&"
import style0 from "./ActivityOpenQuestionItemOption.vue?vue&type=style&index=0&id=674a55e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674a55e2",
  null
  
)

export default component.exports